module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAASCAYAAABrXO8xAAAAjklEQVQ4T2NkYGBgCA39z/xW5EkWiP1PXGb6gQbGPyA2PsAIknTMeJTEwPh/LojNyMiw5p+YXCQhzWCNDlkPQxj/M6yG2UCMZrBGEHDKetTz////YmI1wzWSqhlFIymaMTQSqxmrRmI049RISDP1NRKKHuoFDiGb4AkEOSETqwmcpilKcmQncrKzFTkZGQCqLKgTzNSSbAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/right.png
// module id = vC+O
// module chunks = 1